module.exports = __webpack_public_path__ + "static/media/avatar1.7467b519.png";


//////////////////
// WEBPACK FOOTER
// ./src/avatars/avatar1.png
// module id = 35
// module chunks = 0